import { List, ListProps } from "./List";

import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Home/Watchlist/ForYou";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

interface ForYouProps {
  type: "crypto" | "stock";
  data?: ListProps["data"];
}

export const ForYou = (props: ForYouProps) => {
  const { type, data } = props;
  if (Array.isArray(data) && !data.length) {
    return null;
  }
  return (
    <div className="flex flex-col gap-3 rounded-3 p-4 bg-background_white_overlay5">
      <h3
        aria-label="For You h3"
        data-openreplay-label="For You h3 Semantic"
        id="sem-for-you-h3"
        className={cn("title_l text-content_primary")}
      >
        {type === "crypto" ? I18n.t("Crypto For You") : I18n.t("Stock For You")}
      </h3>
      <List data={data} type={type} />
    </div>
  );
};
